import { jUserLittleSchema } from './user';
import { jArticleLittleSchema, jArticleViewSchema } from './article';
import { jObjectLittleSchema } from './objectBase';
import { rightsSchema } from './common';
import { z } from 'zod';

export const aseiTicketStatusSchema = z.union([z.literal('created'), z.literal('validated'), z.literal('handled')]);
export type AseiTicketStatus = z.infer<typeof aseiTicketStatusSchema>;

export const aseiTicketSchema = jArticleViewSchema.extend({
    aseiClearanceTicketValidator: jUserLittleSchema.array(),
    aseiClearanceTicketHandler: jObjectLittleSchema.array(),
    aseiClearanceTicketApplicationManagers: jObjectLittleSchema.array(),
    aseiClearanceTicketInstitution: jObjectLittleSchema.array(),
    processContext: z.null(),
    _transientCtx: z.null(),
    aseiClearanceTicketNatureOfDemand: z.string(),
    aseiClearanceTicketInternetAccess: z.string(),
    aseiClearanceTicketInternetAccessSpecify: z.string(),
    aseiClearanceTicketMicrosoftTeams: z.string().nullable(),
    aseiClearanceTicketVariousNetworks: z.string().nullable(),
    aseiClearanceTicketFreeText: z.string(),
    aseiClearanceTicketOfficeAccess: z.string().nullable(),
    aseiClearanceTicketSharedDirectoriesSpecify: z.string(),
    aseiClearanceTicketBlueKanGo: z.string().nullable(),
    aseiClearanceTicketAccounting: z.string(),
    aseiClearanceTicketAccountingBudget: z.string(),
    aseiClearanceTicketTransfers: z.string().nullable(),
    aseiClearanceTicketBilling: z.string(),
    aseiClearanceTicketPayroll: z.string(),
    aseiClearanceTicketPayrollBudget: z.string(),
    aseiClearanceTicketAccommodationCosts: z.string(),
    aseiClearanceTicketCommercialManagement: z.string(),
    aseiClearanceTicketInventoryManagement: z.string(),
    aseiClearanceTicketTimeManagement: z.string(),
    aseiClearanceTicketBdes: z.string(),
    aseiClearanceTicketMandateStart: z.string().nullable(),
    aseiClearanceTicketMandateEnd: z.string().nullable(),
    aseiClearanceTicketIndicatorsPlatform: z.string().nullable(),
    aseiClearanceTicketBudgetLetters: z.string(),
    aseiClearanceTicketComputerisedFile: z.string().nullable(),
    aseiClearanceTicketRecruiterAccess: z.string().nullable(),
    aseiClearanceTicketTypeOfWorkContractFrom: z.null(),
    aseiClearanceTicketTypeOfWorkContractTo: z.null(),
    aseiClearanceTicketLastName: z.string(),
    aseiClearanceTicketFirstName: z.string(),
    aseiClearanceTicketUser: jUserLittleSchema.array(),
    aseiClearanceTicketTypeOfWorkContract: z.string(),
    aseiClearanceTicketTypeOfWorkContractSpecify: z.string(),
    aseiClearanceTicketPosition: z.string(),
    aseiClearanceTicketStatus: aseiTicketStatusSchema,
});
export type AseiTicket = z.infer<typeof aseiTicketSchema>;

export const aseiInstitutionSchema = jArticleLittleSchema.extend({
    _right: rightsSchema,
    _user: jUserLittleSchema,
    aseiInstitutionValidator: jObjectLittleSchema.array(),
    processContext: z.null(),
});
export type AseiInstitution = z.infer<typeof aseiInstitutionSchema>;

export const aseiGroupsSchema = z.object({
    dsi: z.string(),
    gestionnaireApplicatif: z.string(),
    createurDemande: z.string(),
});
export type AseiGroups = z.infer<typeof aseiGroupsSchema>;

export const aseiRightsSchema = z.object({
    accessWriter: z.boolean(),
    accessApp: z.boolean(),
});
export type AseiRights = z.infer<typeof aseiRightsSchema>;
